module.exports = __webpack_public_path__ + "static/media/vip-trophy-2.69840f76.png";